<template>
    <div class="flex flex-col md:flex-row">
        <router-link class="text-center bg-blue-500 hover:bg-blue-600 rounded text-white px-5 py-4 w-full md:w-auto font-bold mr-3 mb-24 md:mb-0" v-if="user" to="/cadastro/perfil">
            <i class="fas fa-edit"></i>
            Alterar minhas respostas
        </router-link>
        <a href="#" class="text-center bg-red-500 hover:bg-red-600 rounded text-white px-5 py-4 w-full md:w-auto font-bold" @click.prevent="logout()">
            <i class="fas fa-sign-out-alt"></i>
            Sair
        </a>
    </div>
</template>

<script>
    import {auth} from '../firebase'
    import {mapState} from "vuex";

    export default {
        props: ['user'],
        computed: mapState({
            form: state => state.formulario
        }),
        mounted() {
            this.$store.dispatch('obterFormularioSalvo', this.user.email)
        },
        methods: {
            logout() {
                this.$store.dispatch('logout')
            }
        },
    }
</script>